import React from 'react';


const SVG = ({name, width, height}) => {
  switch (name) {
    case `${name}`:
      return (
        <img
          src={require(`../../assets/svg/${name}.svg`)}
          style={{width: width, height: height}}
        />
      );

    default:
      return '';
  }
};

export default SVG;
